<template>
    <span
        :uk-tooltip="
            disabled
                ? 'title:' + $t('x.module.disabled.hint', {x: $t(module)})
                : ''
        "
        :class="disabled ? 'module-disabled-struct' : ''">
        <span
            :class="
                disabled ? 'module-disabled uk-height-1-1' : 'uk-height-1-1'
            ">
            <TextField
                v-model="nameField.value"
                :icon="nameField.icon"
                :label="nameField.label"
                :name="nameField.name"
                :rules="nameField.rules"
                :on-enter="actionDeclare"
                :validate="trigger"
                @setValid="setValidName" />

            <div class="uk-margin-top" />
            <LabelWithError :label="$t('type') + '*'" />
            <div class="uk-grid-small uk-child-width-1-2" uk-grid>
                <div
                    v-for="variantType in ['select', 'checkbox']"
                    :key="variantType">
                    <span v-on:click="selectedType = variantType">
                        <LabelSelect
                            :is-selected="selectedType === variantType">
                            <div class="uk-text-center">
                                <Translate
                                    :translation-key="
                                        'variant.' + variantType
                                    " />
                            </div>
                        </LabelSelect>
                    </span>
                </div>
            </div>

            <div class="description uk-margin-small-top">
                <Translate translation-key="variant.type.description" />
            </div>

            <div class="uk-margin-top" />
            <LabelWithError :label="$t('options') + '*'" />
            <span v-on:click="addOption()">
                <Button mode="primary">
                    {{
                        $t('x.add', {
                            x: $t('option'),
                        })
                    }}
                </Button>
            </span>
            <div class="uk-margin-bottom" />
            <div
                v-for="(option, key) in selectedOptions"
                :key="'option-' + key"
                class="uk-grid-small uk-grid-match"
                uk-grid>
                <div class="uk-width-expand">
                    <TextField
                        v-model="option[0].value"
                        :field-key="0"
                        :icon="option[0].icon"
                        :identifier="key"
                        :label="option[0].label"
                        :name="option[0].name"
                        :on-enter="actionDeclare"
                        :options="option[0].options"
                        :rules="option[0].rules"
                        :steps="option[0].steps"
                        :type="option[0].type"
                        :validate="trigger"
                        :label-info="option[0].labelInfo"
                        @setValid="setValidOption" />
                </div>
                <div class="uk-width-expand">
                    <CurrencyInput
                        v-model="option[1].value"
                        :icon="option[1].icon"
                        :is-optional="option[1].optional"
                        :label="option[1].label"
                        :name="option[1].name"
                        :on-enter="actionDeclare"
                        :options="computedCurrencyOptions"
                        :rules="option[1].rules"
                        :steps="option[1].steps"
                        :type="option[1].type"
                        :label-info="option[1].labelInfo" />
                </div>
                <div class="uk-width-auto">
                    <LabelWithError class="uk-invisible" label="p" />
                    <span
                        v-if="key !== 0"
                        :uk-tooltip="
                            'title:' +
                            $t('x.delete', {
                                x: $t('option'),
                            })
                        "
                        class="cursor-pointer"
                        v-on:click="removeOption(key)">
                        <Icon icon="trash" />
                    </span>
                    <span v-else :uk-tooltip="'title:' + $t('standard.option')">
                        <Icon icon="check" />
                    </span>
                </div>
            </div>

            <div class="uk-margin-medium-bottom" />
            <div uk-grid>
                <div v-if="newVariant.id" class="uk-width-auto">
                    <div class="uk-button-group">
                        <div class="uk-inline">
                            <span
                                :uk-tooltip="
                                    'title:' + $t('x.delete', {x: $t(formName)})
                                ">
                                <Button is-large is-max mode="danger">
                                    <Icon icon="trash" />
                                </Button>
                            </span>
                            <div
                                uk-dropdown="mode: click; target: !.uk-button-group;">
                                <ul class="uk-nav uk-dropdown-nav">
                                    <Translate
                                        translation-key="variant.delete.message" />
                                    <div class="uk-margin-small-top" />

                                    <Button
                                        :action="actionDelete"
                                        :is-loading="deleteLoading"
                                        has-action
                                        is-large
                                        is-max
                                        mode="danger">
                                        <Translate translation-key="delete" />
                                    </Button>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="uk-width-expand">
                    <Button
                        :action="actionDeclare"
                        :is-loading="loading"
                        :text="
                            $t(newVariant.id ? 'x.change' : 'x.add', {
                                x: $t(formName),
                            })
                        "
                        has-action
                        is-large
                        is-max
                        mode="primary" />
                </div>
            </div>

            <div v-if="error" class="uk-margin-medium-bottom" />
            <ErrorMessage :error="error" />
        </span>
    </span>
</template>

<script>
import Button from '@/components/generic/Button.vue';
import TextField from '@/components/generic/TextField.vue';
import ErrorMessage from '@/components/generic/ErrorMessage.vue';
import axios from 'axios';
import Icon from '@/components/generic/Icon.vue';
import UIkit from 'uikit';
import Translate from '@/components/Translate.vue';
import LabelSelect from '../../components/LabelSelect.vue';
import LabelWithError from '../../components/generic/LabelWithError.vue';
import CurrencyInput from '../../components/generic/CurrencyInput.vue';

export default {
    name: 'VariantForm',
    components: {
        CurrencyInput,
        LabelWithError,
        LabelSelect,
        Translate,
        Icon,
        ErrorMessage,
        TextField,
        Button,
    },
    props: {
        modalId: String,
        disabled: Boolean,

        variant: Object,
    },
    data() {
        return {
            module: 'clickAndBuy',
            formName: 'variant',

            trigger: 0,

            loading: false,
            error: null,

            newVariant: this.variant,

            nameField: {
                value: this.variant.name,
                valid: !!this.variant.name,

                name: 'name',
                label: 'name',
                icon: 'hashtag',
                rules: 'required|max:64',
            },
            selectedType: this.variant.type ?? 'select',
            selectedOptions: [],

            deleteError: null,
            deleteLoading: false,
        };
    },
    computed: {
        computedCurrencyOptions() {
            return {
                currency: this.getInfos.currency,
                currencyDisplay: 'symbol',
                precision: 2,
                hideCurrencySymbolOnFocus: false,
                hideGroupingSeparatorOnFocus: false,
                hideNegligibleDecimalDigitsOnFocus: false,
                autoDecimalDigits: false,
                useGrouping: true,
                accountingSign: false,
            };
        },
    },
    created() {
        for (let i = 0, j = this.variant.options.length; i < j; i++) {
            const option = this.variant.options[i];
            this.addOption(option.name, option.price);
        }
    },
    methods: {
        resetFields() {
            this.nameField = {
                value: this.variant.name,
                valid: !!this.variant.name,

                name: 'name',
                label: 'name',
                icon: 'hashtag',
                rules: 'required|max:64',
            };
            this.selectedType = 'select';
            this.selectedOptions = [];
        },
        removeOption(key) {
            this.selectedOptions.splice(key, 1);
            this.$forceUpdate();
        },
        addOption(name = '', price = 0) {
            if (!this.selectedOptions) {
                this.selectedOptions = [];
            }

            let newStruct = [
                {
                    value: name,
                    valid: name !== '',

                    name: 'name',
                    label: 'name',
                    icon: 'hashtag',
                    rules: 'required',
                    type: 'text',
                },
                {
                    value: price,
                    valid: true,

                    name: 'price',
                    label: 'price',
                    icon: 'tag',
                    rules: '',
                    type: 'number',
                    steps: 0.01,
                },
            ];

            this.selectedOptions.push(newStruct);

            this.$forceUpdate();
        },
        setValidName(valid) {
            this.nameField.valid = valid;
        },
        setValidOption(valid, fieldKey, identifier) {
            this.selectedOptions[identifier][fieldKey].valid = valid;
        },
        actionDelete() {
            this.deleteLoading = true;

            let http = axios.create();
            http.delete(this.apiUrl + '/manage-variants/' + this.newVariant.id)
                .then(() => {
                    this.$emit('declared', this.newVariant.id);

                    this.deleteError = null;
                    this.deleteLoading = false;

                    UIkit.modal('#' + this.modalId).hide();

                    UIkit.notification({
                        message: this.$t('variant.deleted.message'),
                        status: 'info',
                        pos: 'top-center',
                        timeout: this.notificationTimeout,
                    });
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.deleteError = e;
                    this.deleteLoading = false;
                });
        },
        actionDeclare() {
            this.trigger++;

            if (!this.nameField.valid) {
                return;
            }

            for (let i = 0, j = this.selectedOptions.length; i < j; i++) {
                const option = this.selectedOptions[i];
                if (!option[0].valid) {
                    return;
                }
            }

            if (this.newVariant.id) {
                return this.actionUpdate();
            }

            return this.actionCreate();
        },

        actionCreate() {
            this.loading = true;

            let options = [];
            for (let i = 0, j = this.selectedOptions.length; i < j; i++) {
                const option = this.selectedOptions[i];
                let price = undefined;
                if (option[1].value && option[1].value !== 0) {
                    price = option[1].value;
                }

                options.push({
                    name: option[0].value,
                    price: price,
                });
            }

            let http = axios.create();
            http.post(this.apiUrl + '/manage-variants', {
                name: this.nameField.value,
                type: this.selectedType,
                options: options,
            })
                .then((response) => {
                    this.handleSuccess(response.data.id, true);

                    this.resetFields();
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.loading = false;
                });
        },
        actionUpdate() {
            this.loading = true;

            let options = [];
            for (let i = 0, j = this.selectedOptions.length; i < j; i++) {
                const option = this.selectedOptions[i];
                let price = undefined;
                if (option[1].value && option[1].value !== 0) {
                    price = option[1].value;
                }

                options.push({
                    name: option[0].value,
                    price: price,
                });
            }

            let http = axios.create();
            http.put(this.apiUrl + '/manage-variants/' + this.newVariant.id, {
                name: this.nameField.value,
                type: this.selectedType,
                options: options,
            })
                .then((response) => {
                    this.handleSuccess(response.data.id, false);
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.loading = false;
                });
        },
        handleSuccess(id, isNew = false) {
            this.$emit('declared', id);

            UIkit.notification({
                message: this.$t(
                    isNew
                        ? 'variant.created.message'
                        : 'variant.updated.message'
                ),
                status: 'info',
                pos: 'top-center',
                timeout: this.notificationTimeout,
            });

            UIkit.modal('#' + this.modalId).hide();

            this.error = null;
            this.loading = false;
            this.$forceUpdate();
        },
    },
};
</script>

<style lang="scss" scoped>
.description {
    font-size: 14px;
}
</style>
